import { getLanguageData } from '../../utils/i18n/locales/info';
export var getDisplayName = function (locale) { var _a; return ((_a = getLanguageData(locale)) === null || _a === void 0 ? void 0 : _a.displayName) || locale; };
export var getDisplayNameEn = function (locale) { var _a; return ((_a = getLanguageData(locale)) === null || _a === void 0 ? void 0 : _a.displayNameEn) || locale; };
